import StoriesSection from '@components/stories/storiesSection';
import {
    Maybe,
    ModuleFragment,
    ContentStoryFragment,
    useGetModulesQuery,
} from '@graphql/generated/graphql';
import cloneDeep from 'lodash/cloneDeep';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { StateResultsProvided } from 'react-instantsearch-core';
import { connectStateResults } from 'react-instantsearch-dom';
// TODO: find true type definition in react-instant-search

type Story = NonNullable<ContentStoryFragment['Story']>;

const Hits = ({ searchState, searchResults }: StateResultsProvided<Story>) => {
    const [storyModules, setStoryModules] = useState<
        Maybe<Array<Maybe<ModuleFragment>>> | undefined
    >();
    const [filteredModules, setFilteredModules] = useState<
        Maybe<Array<Maybe<ModuleFragment>>> | undefined
    >();

    const router = useRouter();

    const validQuery = true;
    // ... searchState.query?.length >= 3; Can be used to hide the results until something  is entered in the search bar

    const { data, loading } = useGetModulesQuery({
        variables: {
            product:
                typeof router.query.product == 'string'
                    ? router.query.product
                    : '' || '',
            companySlug: router.query.company as string,
            locale: router.locale,
        },
    });

    const hitStoriesId: number[] | undefined = useMemo(() => {
        let tmp;
        if (searchResults) {
            tmp = searchResults.hits.map((story: Story) => Number(story.id));
        }
        return tmp;
    }, [searchResults]);

    useEffect(() => {
        if (
            !data ||
            !data.products ||
            data.products.length == 0 ||
            !data.products[0]
        )
            return;
        const modules = data.products[0].Modules;
        if (!modules) return;
        const storyModules = [...modules]
            .filter((module) => !!module?.Module)
            .filter((module) => module!.Module!.Type == 'stories');

        setStoryModules(storyModules);
    }, [data, loading]);

    useEffect(() => {
        if (storyModules && hitStoriesId) {
            const tmp = cloneDeep(storyModules)
                .map((module) => {
                    module!.Module!.Content = (
                        module?.Module!.Content as ContentStoryFragment[]
                    ).filter(
                        (story) =>
                            story &&
                            story.Story &&
                            hitStoriesId.includes(+story.Story.id)
                    );
                    return module;
                })
                .filter((module) => module!.Module!.Content!.length > 0);
            setFilteredModules(tmp);
        }
    }, [storyModules, hitStoriesId]);

    return (
        <>
            {validQuery &&
                filteredModules &&
                filteredModules.length > 0 &&
                filteredModules.map((module) => (
                    <StoriesSection
                        key={module.Module?.id}
                        module={module}
                        searchQuery={searchState.query}
                    />
                ))}
        </>
    );
};

export default connectStateResults(Hits);
